import { CircularProgress, Stack, Typography, useTheme } from '@mui/material';

import { AlertTriangleIcon } from '@/components/icons/AlertTriangleIcon';
import { COLORS } from '@/styles/tokens/colors';

export function PresentationTemplateEditorLoadingState() {
  return (
    <Stack
      direction="column"
      height="100%"
      width="100%"
      overflow="hidden"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  );
}

export function PresentationTemplateEditorErrorState() {
  const theme = useTheme();
  return (
    <Stack
      direction="column"
      height="100%"
      width="100%"
      overflow="hidden"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      textAlign="center"
      maxWidth={theme.spacing(54)}
    >
      <AlertTriangleIcon color={COLORS.GRAY[300]} size={48} />
      <Typography variant="title-xl">Something went wrong</Typography>
      <Typography variant="body-s" color={COLORS.TEXT.PRIMARY}>
        The presentation template could not be loaded. Please try again later.
      </Typography>
    </Stack>
  );
}
